class CartCrossSell extends HTMLElement {
  constructor() {
    super();
    this.errorEl = this.querySelector('.error');
  }

  connectedCallback() {
    const buttons = this.querySelectorAll('button.add-to-cart');
    for (const button of buttons) {
      button.addEventListener('click', (e) => this.handleProduct(e));
    }
  }

  handleProduct(evt) {
    evt.preventDefault();
    const data = evt.target.nextElementSibling ? JSON.parse(evt.target.nextElementSibling.innerText) : null;
    if (!data) return;

    const firstAvailableVariant = data.variants.find(v => v.available);
    this.addProductToCart({
      productTitle: data.title,
      variantId: firstAvailableVariant.id
    });
  }

  async addProductToCart({productTitle, variantId}) {
    if (!variantId) return;

    this.classList.add('loading');
    try {
      const req = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'items': [{
            'id': variantId,
            'quantity': 1
          }]
        })
      });
      const res = await req.json();

      if (!req.ok) {
        this.handleError({res, variantId});
      }

      try {
        const req1 = await fetch(`${window.Shopify.routes.root}cart.js`);
        const res1 = await req1.json();

        console.log({ req1, res1 })
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-cross-sell',
          productVariantId: variantId,
          cartData: res1,
        });
      } catch (error) {
        this.handleError({error, variantId});
      }

      // console.log(`Cross sell product added to cart`, {productTitle});
    } catch (error) {
      this.handleError({error, variantId});
    } finally {
      this.classList.remove('loading');
    }
  }

  handleError({error, id}){
    publish(PUB_SUB_EVENTS.cartError, {
      source: 'cart-cross-sell',
      variantId: id,
      errors: error.errors || error.description,
      message: error.message,
    });

    if (this.errorEl) {
      this.errorEl.innerHTML = '';
      this.errorEl.innerHTML = error.message || error.description;
    }
  }
}

if (!customElements.get('cart-cross-sell')) {
  customElements.define('cart-cross-sell', CartCrossSell);
}